import { formatMoney } from "../lib/money.js";
import "./StickyBar.css";

interface StickyBarProps {
  count: number;
  totalCents: number;
}

/** Where the bar sends you. Matches the `id` on the ticket. */
const TICKET_ID = "ticket";

export default function StickyBar({ count, totalCents }: StickyBarProps) {
  const showing = count > 0;

  const goToTicket = () => {
    const target = document.getElementById(TICKET_ID);
    if (!target) return;
    // tokens.css kills animation globally under prefers-reduced-motion, but a
    // scroll started from script is not covered by that rule, so it is asked
    // here instead of being fought there.
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    target.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
  };

  return (
    /* Always rendered so it has somewhere to slide from. When the cart is
       empty the CSS sets visibility:hidden, which takes it out of the tab
       order and the accessibility tree without needing aria-hidden — and,
       unlike display:none, still lets the transform animate. */
    <div className={`stickybar${showing ? " stickybar--up" : ""}`}>
      <div className="stickybar__inner">
        <p className="stickybar__sum">
          <span className="stickybar__count">
            {count} {count === 1 ? "item" : "items"}
          </span>
          <span className="stickybar__total">{formatMoney(totalCents)}</span>
        </p>
        <button type="button" className="stickybar__go" onClick={goToTicket}>
          View ticket
        </button>
      </div>
    </div>
  );
}
